import { plainToInstance, Type } from 'class-transformer'
import { IParticipant } from './IParticipant'
import { Briefing, ParticipantRole, ParticipantStatus } from './types'
import { User } from '@core/entities/user'

export class Participant extends User<IParticipant> {
  externalId?: string // Present for the external users
  userId?: number // Present for the internal users

  signed: boolean
  signatureId: number
  @Type(() => User)
  signedVia?: User
  lastSignedOn: string
  roles: Array<ParticipantRole>
  briefing: Briefing
  status: ParticipantStatus

  public static new(payload: unknown): Participant {
    const entity = plainToInstance(Participant, payload)

    return entity
  }

  public getRole(): string {
    return this.roles.map(({ name }) => name).join(', ')
  }

  public getPendingAcceptanceRoles(): Array<ParticipantRole> {
    return (this.roles || []).filter(
      ({ briefingAcceptanceStatus }) =>
        briefingAcceptanceStatus === 'PENDING_ACCEPTANCE',
    )
  }

  public hasPendingAcceptance(): boolean {
    return this.getPendingAcceptanceRoles().length > 0
  }

  public getBriefingFormattedText(): string {
    const bodyWithoutHtmlTags = this.briefing.briefingText
      .replace(/<\/?[^>]+(>|$)/g, '')
      .replace(/&nbsp;/g, '')

    return bodyWithoutHtmlTags
  }

  public toUser(): User {
    return User.new({
      id: this.userId,
      email: this.email,
      firstName: this.firstName,
      lastName: this.lastName,
      phone: this.phone,
      company: this.company,
      companyId: this.companyId,
      avatarUrl: this.avatarUrl,
    })
  }

  // If the participant is an external user, they won't have a userId
  public isExternalUser(): boolean {
    return !this.userId
  }

  // If the participant is an SiteAssist user, they will have a userId
  public isSiteAssistUser(): boolean {
    return !!this.userId
  }
}
